import type { IconProps } from './types';

export const PlayIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 12C3 7.02944 7.02944 3 12 3C16.9705 3 21 7.02944 21 12C21 16.9705 16.9705 21 12 21C7.02944 21 3 16.9705 3 12ZM9 6.83727L10.1229 7.48082L16.8729 11.3492L18.0083 11.9999L16.8729 12.6507L10.1229 16.5191L9 17.1626V6.83727Z"
        fill={color}
      />
    </svg>
  );
};
